/**
 * Shared Chart Theme Colors — Impact Core Design System
 *
 * Consistent palette for all Recharts visualizations across the platform.
 * Ordered for maximum contrast and accessibility in both light and dark themes.
 */

export const IC_CHART_COLORS = [
  '#2563EB', // Blue (primary)
  '#00B67A', // Emerald
  '#F5A623', // Amber
  '#E5484D', // Red
  '#8B5CF6', // Violet
  '#0891B2', // Cyan
  '#DC2626', // Crimson
  '#7C3AED', // Purple
] as const;

/**
 * Tooltip style shared across all chart widgets.
 */
export const IC_CHART_TOOLTIP_STYLE = {
  backgroundColor: '#1E293B',
  border: '1px solid #334155',
  borderRadius: '6px',
  fontSize: '12px',
  color: '#E2E8F0',
} as const;
